
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
  name: "Loading",
  inject: ["RootState"],
});
